import { EventEmitter, Injectable } from '@angular/core';
import { Pagination } from '@models/pagination.model';
import { SharedDataService } from '@services/shared-data.service';
import { ToastrService } from 'ngx-toastr';
import { SortEvent } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { ApiService } from '../api/api.service';

import $ from 'jquery';
import { BehaviorSubject, filter, fromEvent, Subject } from 'rxjs';
import { ListingPropertiesService } from '../api/listing-properties.service';
import { Crypto } from '../helpers/encryption-utils';
import { LocalStorageService } from '../helpers/local-storage.service';
import { Utils } from '../helpers/utils';
import { ActivityEntityType, ActivityRecord, ActivityTrackerService } from '../user-activity/activity-tracker.service';

/**
 * Drawer tab `module` values that name the record type outright.
 *
 * ADDING A NEW DRAWER TAB TYPE? Add it here (or give it a name prefix below). A tab that matches
 * neither table sends no `record_open` at all, so it silently stops showing as "Lead: John Smith"
 * in Current Activity on the User Activity dashboard.
 */
const ACTIVITY_TAB_MODULES: Record<string, ActivityEntityType> = {
  lead: 'lead',
  contact: 'contact',
  eoi: 'eoi',
  lot: 'lot',
  staff: 'staff',
};

/**
 * Otherwise the tab name's prefix does — and it is spelt inconsistently across callers
 * (`Contact-Jane`, `Contact - Jane`, `Task: REM-12`, `Task-12`), hence word-boundary matches.
 * `Contract` must not be read as `Contact`, which `\b` guarantees.
 */
const ACTIVITY_TAB_PREFIXES: [RegExp, ActivityEntityType][] = [
  [/^Lead\b/, 'lead'],
  [/^Contact\b/, 'contact'],
  [/^Contract\b/, 'contract'],
  [/^Task\b/, 'task'],
  [/^EOI\b/, 'eoi'],
  [/^Lot\b/, 'lot'],
  [/^Listing\b/, 'listing'],
  [/^Property\b/, 'property'],
  [/^Project\b/, 'project'],
  [/^Staff\b/, 'staff'],
];

@Injectable({
  providedIn: 'root',
})
export class LeadManagementService {
  exportProjectAllocationsCarStorage: { project_logo_folder: any; project_details: any } = { project_details: null, project_logo_folder: null };

  pinChanged: EventEmitter<string> = new EventEmitter();
  current_URL: EventEmitter<string> = new EventEmitter();

  selected_workflow = null;
  isApproval_properties = false;
  backToEOIList = false;
  saleBoardToEOi: any = null;
  properties_module: boolean = false;
  isRelated_add: boolean = false;
  tag_manager = false;
  tabIndex: any;
  /**
   * Transient: a tab the AI assistant wants opened when it deep-links into a lead
   * (e.g. 'appointment'), or a report row that links to a lead's 'horizon' tab. Set right
   * before navigating to the lead (`?id=…`); the lead detail
   * reads it once on load, switches to that tab, then clears it.
   */
  aiLeadTab: string | null = null;
  refresh_lead_model = true;
  isHide_EoiLot = true;
  insertedId: any;

  is_new_lead = false;
  public role_id = '';
  public SortBy = '';
  public Pagination: Pagination;
  public total: any;
  isPortal = false;
  propIdForRightBar: any;
  prop_reload_rightBar: boolean;
  is_menu_hide: boolean = true;
  aliasIndex: any;
  cont_id: any;
  is_new_task = false;
  is_new_listing = false;
  reload_rightBar: boolean;
  reload_add_contacts: boolean;
  show_div = 'add_listing_property';
  contact_create_ele: any;
  contact_show_div: string;
  isEdit_show_div: string;
  listing_show_div: string;
  property_show_div: string;
  company_show_div: string;
  contract_show_div: string;
  property_ownersIds: any;
  contractId: any;
  isListingContract = false;
  contact_type: any = null;
  company_name: any = null;
  sideNavToggle: boolean = false;
  showRightBar = false;
  project_showRightBar = false;
  contact_showRightBar = false;
  contract_showRightBar = false;
  showIcons = true;
  propertyId: any;
  openRightBarwhenClickPlusButton: boolean = false;
  leadLoader = false;
  contactNavUpdated = new BehaviorSubject<boolean>(false);
  agencyListUpdated$ = new Subject<void>();

  rosters: any;
  rostersCopy: any;
  selectedStatus = null;
  selectedRoster = null;
  level: any;
  ind: any;

  status = [
    {
      id: 1,
      name: 'Active',
    },
    {
      id: 2,
      name: 'Inactive',
    },
  ];
  baseurl = environment.nodeApiUrl + '/' + environment.api_prefix;
  query = null;

  leads: any;
  projectsCopy: any;
  projects: any;
  Projectlength: any;
  selectedRows: any = [];
  leadsToDelete = [];

  ownerID: any;
  selecteProjectdRows: any = [];
  contact_relations: any;

  visibilitySetting;
  property_features: any[] = [];
  enquiry_sources: any;
  public Users: any[];
  public UserCompanies: any[];
  public Company: any[];
  public dashboardContactPagination: any[];
  tab_levels = [];
  quickAccess = [];
  activeTabIndex: number = 0;
  pined_tabs = [];
  pinPage = {
    name: null,
    pin_id: null,
    data: null,
    extra: {},
    link: null,
    param: null,
  };
  office_id;
  localID;
  constructor(
    private toast: ToastrService,
    private sds: SharedDataService,
    private Api: ApiService,
    private localStorageService: LocalStorageService,
    private _listingPropertiesService: ListingPropertiesService,
    private activityTracker: ActivityTrackerService
  ) {
    this.office_id = Crypto.decrypt(this.localStorageService.GetItem('officeid'));
    this.localID = Crypto.decrypt(this.localStorageService.GetItem('uid'));
    this.contact_showRightBar = false;
    this.reload_rightBar = false;
    this.tab_levels = [];

    // Listen globally for 'Escape' key
    fromEvent<KeyboardEvent>(document, 'keydown')
      .pipe(filter(event => event.key === 'Escape'))
      .subscribe(() => this.onEscPress());
  }

  private onEscPress() {
    console.log('ESC pressed globally via service');
    this.showRightBar = false;
    this.contact_showRightBar = false;
    this.reload_rightBar = false;
    this.tab_levels = [];
    // You can also emit an event via a Subject here if multiple components should react
  }

  private floorplan_upload = new Subject<any>();
  private projectRendered = new Subject<any>();
  private leadUpdated = new Subject<any>();
  private notMatchFloorPlan = new Subject<any>();
  private rendorProjectSummary = new Subject<any>();

  isShowAllRecords = false;
  isDateReset = false;
  planUpload(floor_plan) {
    this.floorplan_upload.next(floor_plan);
  }

  reRenderFloorPlan() {
    return this.floorplan_upload.asObservable();
  }

  isProjectUpload(isProject) {
    this.projectRendered.next(isProject);
  }
  isRendorProject() {
    return this.projectRendered.asObservable();
  }

  noMatchFloorPlan(floor_plan) {
    this.notMatchFloorPlan.next(floor_plan);
  }
  getNoMatchFloorPlan() {
    return this.notMatchFloorPlan.asObservable();
  }

  updateProjectSummary(summary) {
    this.rendorProjectSummary.next(summary);
  }

  getProjectSummary() {
    return this.rendorProjectSummary.asObservable();
  }

  isLeadUpdate(isLead) {
    this.leadUpdated.next(isLead);
  }
  isRendorOffice() {
    return this.leadUpdated.asObservable();
  }

  customSort(event: SortEvent) {
    if (event.field === 'lot_price') {
      event.data.sort((data1, data2) => {
        let value1 = Utils.cleanAndFormatPrice(data1?.[event?.field]) || 0;
        let value2 = Utils.cleanAndFormatPrice(data2?.[event?.field]) || 0;
        if (event.order === -1) {
          return value1 - value2; // Ascending order
        } else {
          return value2 - value1; // Descending order
        }
      });
    } else if (event.field === 'level') {
      const sortByLevelDescending = (a: any, b: any) => {
        const getLevelNumber = (str: string) => {
          const match = str?.match(/\d+/) || '';
          return match ? parseInt(match?.[0]) : -1; // Return -1 if no number found
        };

        const aLevel = getLevelNumber(a.level);
        const bLevel = getLevelNumber(b.level);

        if (aLevel === bLevel) {
          return b.level.localeCompare(a.level); // If levels are equal, sort alphabetically in reverse
        }

        return bLevel - aLevel; // Sort based on the numeric value of the level in reverse
      };
      const sortByLevelAscending = (a: any, b: any) => {
        const getLevelNumber = (str: string) => {
          const match = str?.match(/\d+/) || '';
          return match ? parseInt(match?.[0]) : -1; // Return -1 if no number found
        };

        const aLevel = getLevelNumber(a.level);
        const bLevel = getLevelNumber(b.level);

        if (aLevel === bLevel) {
          return a.level.localeCompare(b.level); // If levels are equal, sort alphabetically
        }

        return aLevel - bLevel; // Sort based on the numeric value of the level
      };
      if (event.order === -1) {
        event.data.sort(sortByLevelDescending);
      } else {
        event.data.sort(sortByLevelAscending);
      }
    } else {
      event.data.sort((data1, data2) => {
        let value1 = data1[event.field];
        let value2 = data2[event.field];
        let result = null;

        if (value1 == null && value2 != null) result = -1;
        else if (value1 != null && value2 == null) result = 1;
        else if (value1 == null && value2 == null) result = 0;
        else if (typeof value1 === 'string' && typeof value2 === 'string') result = value1.localeCompare(value2);
        else result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;

        return event.order * result;
      });
    }
  }

  ProjectDetail: any;
  GetProjectDetail(id) {
    this.Api.get(`/project-short-detail/${id}`).subscribe((response: any) => {
      this.ProjectDetail = response?.data;
    });
  }

  ProjectList: any[] = [];
  GetProjectList() {
    this.Api.get(`/projects-name-list?office_id=${this.Api.getOfficeId()}`).subscribe((response: any) => {
      const { status, data } = response;
      if (status) {
        this.ProjectList = data?.sort((a, b) => a?.Project_Name?.trim().localeCompare(b?.Project_Name?.trim()));
      }
    });
  }
  properties: any[] = [];
  getProperties(value = true) {
    if (this.Api.getOfficeId()) {
      this._listingPropertiesService.getShortListing(false, value, false, true).subscribe(res => {
        this.properties = [];
        this.properties = res?.data;
      });
    }
  }
  agents: any[] = [];
  getAgents() {
    this.Api.get('/users/byoffice?office=' + this.Api.getOfficeId() + '&show=staff').subscribe(res => {
      this.agents = res.data.map(i => {
        i.full_name = i.first_name + ' ' + i.last_name;
        return i;
      });
    });
  }

  unitList: any[] = [];
  available_List: any[] = [];
  async getUnit(e, isAll: boolean = false) {
    if (e) {
      let queryParams = {
        project_id: [e],
      };
      this.Api.post(`/unit-short-detail?office_id=${this.Api.getOfficeId()}`, queryParams).subscribe((response: any) => {
        this.unitList = response?.data;
        if (isAll) {
          this.available_List = response?.data;
        } else {
          this.available_List = response?.data?.filter(
            ele => ele?.status_reason?.toLowerCase() == 'for sale' || ele?.status_reason?.toLowerCase() == 'available'
          );
        }
      });
    }
  }

  getPropertyFeatures() {
    this.Api.getApi(
      `/eng/misc/entity/getallbyname?entityname=property_feature&userid=${this.sds.getUserId()}&officeid=${this.sds.getOfficeId()}`
    ).subscribe(res => {
      this.property_features = [];
      this.property_features = res['data'];
    });
  }

  getContactRelations() {
    this.Api.get(
      `/eng/misc/entity/getallbyname?entityname=contact_relation&userid=${this.sds.getUserId()}&officeid=${this.sds.getOfficeId()}`
    ).subscribe(res => {
      this.contact_relations = res['data'];
    });
  }

  getEnquirySource() {
    this.Api.get(
      `/eng/misc/entity/getallbyname?entityname=enquiry_source&userid=${this.sds.getUserId()}&officeid=${this.sds.getOfficeId()}`
    ).subscribe(res => {
      this.enquiry_sources = res['data'];
    });
  }

  deleteImage(id, url, type) {
    this.Api.delete('/users/profile-images/' + id, {
      type: type,
      profile_image: url,
    }).subscribe(() => {
      this.toast.success('Image has been deleted');
    });
  }

  // i have comment these to add custom column filter + sort (REM-771)

  shortCompany: any[] = [];
  shortContactCompany: any[] = [];
  agentContactCompany: any[] = [];
  cshortContactCompany: any[] = [];
  developer_list: any[] = [];
  theshortContacts: any[] = [];
  shortCompanyAllocations: any[] = [];
  shortContactCompanyAllocations: any[] = [];
  cshortContactCompanyAllocations: any[] = [];
  theshortContactsAllocations: any[] = [];
  getShortContactsAllocations(pid, callback?: (value: any) => void) {
    if (this.Api.getOfficeId()) {
      this.Api.get(
        `/contacts?office_id=${this.sds.getOfficeId()}&user_type=Contact&uid=${this.sds.getUserId()}&is_short=${true}&project_id=${pid}&sort_by=${'project_leads'}`
      ).subscribe(data => {
        this.shortCompanyAllocations = [];
        this.shortContactCompanyAllocations = [];
        this.shortCompanyAllocations = data.data.filter(x => x?.type === 'Company').sort((a, b) => a?.company_name?.localeCompare(b?.company_name));
        this.shortContactCompanyAllocations = data.data.sort((a, b) => a?.full_name?.localeCompare(b?.full_name));
        this.cshortContactCompanyAllocations = [...this.shortContactCompany];
        this.theshortContactsAllocations = data.data.sort((a, b) => a?.full_name?.localeCompare(b?.full_name))?.filter(x => x?.type !== 'Company');
        callback && callback(this.theshortContactsAllocations || []);
      });
    }
  }
  getShortContacts(tiny = false, callbackfunc?: () => any) {
    if (this.Api.getOfficeId()) {
      this.Api.getApi(
        `/contacts/list?office_id=${this.sds.getOfficeId()}&user_type=Contact&uid=${this.sds.getUserId()}&tiny=${tiny}&is_short=${true}&page_size=9000`
      ).subscribe(data => {
        this.shortCompany = [];
        this.shortContactCompany = [];
        this.shortCompany = data.data.filter(x => x?.type === 'Company').sort((a, b) => a?.company_name?.localeCompare(b?.company_name));
        this.shortContactCompany = data.data.sort((a, b) => a?.full_name?.localeCompare(b?.full_name));
        this.developer_list = data?.data
          ?.filter(x => x?.contact_type === 'Developer' || x?.company_type === 'Developer')
          .sort((a, b) => a?.full_name?.localeCompare(b?.full_name));
        this.agentContactCompany = data.data.filter(x => x?.contact_type === 'Agent').sort((a, b) => a?.full_name?.localeCompare(b?.full_name));
        this.cshortContactCompany = [...this.shortContactCompany];
        this.theshortContacts = data.data.sort((a, b) => a?.full_name?.localeCompare(b?.full_name));
        this.theshortContacts = data.data.filter(x => x?.contact_type !== 'Company');
        callbackfunc && callbackfunc();
      });
    }
  }

  getContactList(page = 1, per_page = 30, keyword) {
    let params = {
      type: 'All',
      page: page,
      per_page: per_page,
      user_type: 'Contact',
      search: keyword?.toLowerCase() || '',
      company_type: '', // Serialize company type if available
      contact_type: '', // Serialize contact type if available
      sort_order: '', // Convert sorting order to string
      filter: '', // Convert filters to string if present
    };
    // API call to fetch contacts with applied filters, pagination, and sorting
    this.Api.get(`/contacts/list?office_id=${this.Api.getOfficeId()}&uid=${this.Api.getUserId()}`, params).subscribe(data => {
      this.shortCompany = [];
      this.shortContactCompany = [];
      this.shortCompany = data.data.filter(x => x?.type === 'Company').sort((a, b) => a?.company_name?.localeCompare(b?.company_name));
      this.shortContactCompany = data.data.sort((a, b) => a?.full_name?.localeCompare(b?.full_name));
      this.developer_list = data?.data
        ?.filter(x => x?.contact_type === 'Developer' || x?.company_type === 'Developer')
        .sort((a, b) => a?.full_name?.localeCompare(b?.full_name));
      this.agentContactCompany = data.data.filter(x => x?.contact_type === 'Agent').sort((a, b) => a?.full_name?.localeCompare(b?.full_name));
      this.cshortContactCompany = [...this.shortContactCompany];
      this.theshortContacts = data.data.sort((a, b) => a?.full_name?.localeCompare(b?.full_name));
      this.theshortContacts = data.data.filter(x => x?.contact_type !== 'Company');
    });
  }

  addTabInLevels(name, id, lead = null, extra = {}, module = null, isActiveZeroIndex = false) {
    $('.rightbar-tab-link')?.removeClass('active');
    let exist = this.tab_levels.find(el => el?._id == id && el.name === name);
    if (!exist) {
      // startsWith, not includes: every real Listing tab name is built with 'Listing' as a
      // literal prefix (e.g. 'Listing - 12 Smith St'). A Lead tab's title embeds the project
      // name (`Lead - ${project}: ${name}`), so includes() false-matched any project whose
      // name happens to contain "Listing" (e.g. "YPM Residential Listings").
      if (name?.startsWith('Listing')) {
        this.tab_levels = [];
      }
      this.tab_levels.push({
        name: name,
        _id: id,
        data: lead,
        extra: extra,
        module: module,
      });

      this.activeTabIndex = this.tab_levels?.length - 1;
      if (isActiveZeroIndex) {
        setTimeout(() => {
          this.activeTabIndex = 0;
        }, 500);
      }
    } else {
      let ind = this.tab_levels.indexOf(exist);
      let sanitizedName = this.sanitizeSelector(exist?.name + '_' + ind);
      $('.' + sanitizedName).addClass('active');
      this.activeTabIndex = ind;
    }
    this.reportRecordOpen({ name, _id: id, module }, lead);
  }

  /**
   * The drawer's active tab is read live at heartbeat time: tabs are switched and the drawer is
   * closed from dozens of components, none of which would otherwise tell the tracker.
   */
  private reportRecordOpen(tab: { name: string; _id: any; module: string }, data: any): void {
    const record = this.activityRecordFor(tab);
    if (record) {
      const projectId = typeof data?.project_id === 'string' ? data.project_id : null;
      this.activityTracker.openRecord(record, projectId, () => this.activityRecordFor(this.tab_levels?.[this.activeTabIndex]));
    }
  }

  private activityRecordFor(tab: any): ActivityRecord | null {
    const moduleType = ACTIVITY_TAB_MODULES[(tab?.module || '').toString().toLowerCase()];
    const entityType = moduleType ?? ACTIVITY_TAB_PREFIXES.find(([prefix]) => prefix.test((tab?.name || '').toString().trim()))?.[1];
    return entityType && tab?._id ? { entity_type: entityType, entity_id: String(tab._id) } : null;
  }

  sanitizeSelector(selector) {
    return selector.replace(/([!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~])/g, '\\$1');
  }

  pinUpdate(text) {
    this.pinChanged.next(text);
  }
  getUpdatesOfPin() {
    return this.pinChanged;
  }
  reloadLead(_level, ind) {
    this.activeTabIndex = ind;
  }

  pin_button: boolean = false;
  pinTab(tab, _isNew = null) {
    try {
      if (this.isPinning == false) {
        this.pin_button = true;
        setTimeout(() => {
          this.pin_button = false;
        }, 50);
        let tempTab = Object.assign({}, tab);
        let item = null;

        if (tab?.data == null && tab.hasOwnProperty('link')) {
          item = this.pined_tabs.find(el => el.link == tab?.link && el.name == tab.name);
        } else {
          item = this.pined_tabs.find(el => el.pin_id == tab?.data?._id || el.name == tab?.name);
        }
        if (item) {
          this.pined_tabs.splice(item);
          this.deletePinTab(item?._id);
          return;
        } else {
          if (tab?.data !== null) {
            if (tab?.name?.includes('Property')) {
              tempTab.link = '/property/properties';
              tempTab.name = 'Property - ' + tab?.data?.property_address;
            } else if (tab?.name?.includes('Listing')) {
              tempTab.link = '/listings/listing-properties';
            } else if (tab?.name?.includes('Contract')) {
              tempTab.link = '/contracts';
              tempTab.name = 'Contract - ' + tab?.data?.full_name;
            } else if (tab?.name?.includes('Contact')) {
              tempTab.link = '/setting/office-contact';
              tempTab.name = 'Contact - ' + tab?.data?.full_name;
            } else if (tab?.name?.includes('Lead')) {
              tempTab.link = '/leads';
              tempTab.name = 'Lead - ' + tab?.data?.first_name + ' ' + tab?.data?.last_name;
            } else if (tab?.name?.includes('Task')) {
              tempTab.link = '/tasks/all-tasks';
              tempTab.name = 'Task - ' + tab?.data?.title;
            } else if (tab?.name?.includes('Lot')) {
              tempTab.link = '/listings/lot';
              tempTab.name = 'Lot - ' + tab?.data?.lot_name;
            } else if (tab?.name?.includes('EOI')) {
              tempTab.link = '/listings/listing-eoi';
              tempTab.name = 'EOI - ' + tab?.data?.client_first_name;
            }
            tempTab.pin_id = tab?.data?._id;
            delete tempTab._id;
          } else {
            if (tab?.data == null && tab.hasOwnProperty('_id')) {
              if (tab?.name?.includes('Property')) {
                tempTab.link = '/property/properties';
              } else if (tab?.name?.includes('Listing')) {
                tempTab.link = '/listings/listing-properties';
              } else if (tab?.name?.includes('Contract')) {
                tempTab.link = '/contracts';
              } else if (tab?.name?.includes('Contact')) {
                tempTab.link = '/setting/office-contact';
              } else if (tab?.name?.includes('Lead')) {
                tempTab.link = '/leads';
              } else if (tab?.name?.includes('Task')) {
                tempTab.link = '/tasks/all-tasks';
              } else if (tab?.name?.includes('Lot')) {
                tempTab.link = '/listings/lot';
              } else if (tab?.name?.includes('EOI')) {
                tempTab.link = '/listings/listing-eoi';
              }
              tempTab.pin_id = 'createnew';
              delete tempTab._id;
            } else if (tab?.data == null && !tab.hasOwnProperty('_id')) {
              if (tab?.name?.includes('Property')) {
                tempTab.link = '/property/properties';
              } else if (tab?.name?.includes('Listing')) {
                tempTab.link = '/listings/listing-properties';
              } else if (tab?.name?.includes('Contract')) {
                tempTab.link = '/contracts';
              } else if (tab?.name?.includes('Contact')) {
                tempTab.link = '/setting/office-contact';
              } else if (tab?.name?.includes('Lead')) {
                tempTab.link = '/leads';
              } else if (tab?.name?.includes('Task')) {
                tempTab.link = '/tasks/all-tasks';
              } else if (tab?.name?.includes('Lot')) {
                tempTab.link = '/listings/lot';
              } else if (tab?.name?.includes('EOI')) {
                tempTab.link = '/listings/listing-eoi';
              }
              tempTab.pin_id = null;
              delete tempTab._id;
            }
          }
          this.postPinPage(tempTab);
          // this.pined_tabs = [tab, ...this.pined_tabs];
        }
      }
    } catch (error) {
      this.isPinning = false;
    }
  }
  shareLink(tab, _openModelId = null) {
    try {
      this.pin_button = true;
      setTimeout(() => {
        this.pin_button = false;
      }, 50);
      let tempTab = Object.assign({}, tab);
      if (tab?.data !== null) {
        if (tab?.name?.includes('Property')) {
          tempTab.link = '/property/properties';
          tempTab.name = 'Property - ' + tab?.data?.property_address;
        } else if (tab?.name?.includes('Listing')) {
          tempTab.link = '/listings/listing-properties';
        } else if (tab?.name?.includes('Contract')) {
          tempTab.link = '/contracts';
          tempTab.name = 'Contract - ' + tab?.data?.full_name;
        } else if (tab?.name?.includes('Contact')) {
          tempTab.link = '/setting/office-contact';
          tempTab.name = 'Contact - ' + tab?.data?.full_name;
        } else if (tab?.name?.includes('Lead')) {
          tempTab.link = '/leads';
          tempTab.name = 'Lead - ' + tab?.data?.first_name + ' ' + tab?.data?.last_name;
        } else if (tab?.name?.includes('Task')) {
          tempTab.link = '/tasks/all-tasks';
          tempTab.name = 'Task - ' + tab?.data?.title;
        }
        tempTab.pin_id = tab?.data?._id;
        delete tempTab._id;
      } else {
        if (tab?.data == null && tab.hasOwnProperty('_id')) {
          if (tab?.name?.includes('Property')) {
            tempTab.link = '/property/properties';
          } else if (tab?.name?.includes('Listing')) {
            tempTab.link = '/listings/listing-properties';
          } else if (tab?.name?.includes('Contract')) {
            tempTab.link = '/contracts';
          } else if (tab?.name?.includes('Contact')) {
            tempTab.link = '/setting/office-contact';
          } else if (tab?.name?.includes('Lead')) {
            tempTab.link = '/leads';
          } else if (tab?.name?.includes('Task')) {
            tempTab.link = '/tasks/all-tasks';
          }
          tempTab.pin_id = 'createnew';
          delete tempTab._id;
        } else if (tab?.data == null && !tab.hasOwnProperty('_id')) {
          if (tab?.name?.includes('Property')) {
            tempTab.link = '/property/properties';
          } else if (tab?.name?.includes('Listing')) {
            tempTab.link = '/listings/listing-properties';
          } else if (tab?.name?.includes('Contract')) {
            tempTab.link = '/contracts';
          } else if (tab?.name?.includes('Contact')) {
            tempTab.link = '/setting/office-contact';
          } else if (tab?.name?.includes('Lead')) {
            tempTab.link = '/leads';
          } else if (tab?.name?.includes('Task')) {
            tempTab.link = '/tasks/all-tasks';
          }
          tempTab.pin_id = null;
          delete tempTab._id;
        }
      }
      var evt = new CustomEvent('sharelink', { detail: { routeLink: tempTab?.link, ...tab } });
      window.dispatchEvent(evt);
    } catch (error) {
      this.isPinning = false;
    }
  }
  checkPinned(tab) {
    let item = null;
    if (tab?.data == null && tab.hasOwnProperty('link')) {
      item = this.pined_tabs.find(el => el.link == tab?.link && el.name == tab.name);
    } else {
      item = this.pined_tabs.find(el => el.pin_id == tab?.data?._id || el.name == tab.name);
    }
    if (item) {
      return true;
    } else {
      return false;
    }
  }

  isPinning: Boolean = false;
  postPinPage(page) {
    try {
      this.isPinning = true;
      page.user_id = this.sds.getUserId();
      this.Api.post('/general/pin-settings', page).subscribe(
        res => {
          this.isPinning = false;
          this.toast.success(res?.message);
          this.getPinnedTabs();
        },
        () => {
          this.isPinning = false;
        }
      );
    } catch (error) {
      this.isPinning = false;
    }
  }

  getPinnedTabs() {
    try {
      this.isPinning = true;
      let userId = this.Api.getUserId();
      this.Api.get('/general/pin-settings?user_id=' + userId).subscribe(
        res => {
          this.isPinning = false;
          this.pined_tabs = res?.data;
          let param = res?.data?.length > 0 ? 'true' : 'remove';
          this.pinUpdate(param);
        },
        () => {
          this.isPinning = false;
        }
      );
    } catch (error) {
      this.isPinning = false;
    }
  }
  deletePinTab(id) {
    try {
      this.isPinning = true;
      this.Api.delete('/general/pin-settings/' + id).subscribe(
        res => {
          this.toast.success(res?.message);
          this.isPinning = false;
          this.getPinnedTabs();
        },
        () => {
          this.isPinning = false;
        }
      );
    } catch (error) {
      this.isPinning = false;
    }
  }

  currentURL(text) {
    this.current_URL.next(text);
  }

  getUpdateURL() {
    return this.current_URL;
  }

  getLeadsListByOfficeId(payload: any, page?: number, pageSize?: number) {
    return this.Api.get(
      `/get-all-leads?office_id=${this.Api.getOfficeId()}${pageSize ? `&per_page=${pageSize}` : ''}${page ? `&page=${page}` : ''}`,
      payload
    );
  }
}
